
import { isNullOrUndefined } from '../utils/generalFunctions';
import { store } from './store';
import * as types from "./types"
import * as con from "../Constants"


export const getStoredValue = (key) => {
    let val = store.getState()[key]
    if (val === "null" || val === "undefined" || isNullOrUndefined(val))
        val = null
    return (val)
}


export const setStoredValue = (key, value) => {
    let payload = { [con.KEY]: key, [con.VALUE]: value }

    store.dispatch({
        type: types.SET_VALUE_IN_STORAGE,
        payload: payload
    })
}

export const setMultipleStoredValues = (keyValueDict) => {
    let payload = { [con.KEY_VALUE_DICT]: keyValueDict }

    store.dispatch({
        type: types.SET_MULTIPLE_VALUES_IN_STORAGE,
        payload: payload
    })
}